module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_search_plan-0cc6f3803953a4acbecc9e4bbc22fd9e.svg";